import React from "react";
import { MarkerStore, BookUtils } from "../../flux";

const PrintNotes = ({ notes }) => {
  const renderNotes = () => {
    if (notes) {
      var lastChapter = "";
      return notes.map(
        function(note, key) {
          var content = [];
          var chapter = BookUtils.getChapterTitleForCFI(note.cfi, {
            maxLevel: 1
          });

          if (chapter !== lastChapter) {
            content.push(<h1 key={key}>{chapter}</h1>);
            lastChapter = chapter;
          }
          content.push(<span>{note.userInitials}</span>);
          content.push(
            <span>{MarkerStore.getAll().markerHash[note.markerId].label}</span>
          );
          content.push(
            <span className="modified-date">{note.lastModifiedString}</span>
          );
          content.push(
            <div className="note">
              <p>{note.selectedText}</p>
              <p>{note.noteText && <hr />}</p>
              <p>
                <b>{note.noteText}</b>
              </p>
            </div>
          );
          return content;
        }.bind(this)
      );
    }
    return <span />;
  };

  return (
    <div className="print-full-screen">
      <div className="left-column">{renderNotes()}</div>
      <div className="right-column">
        <h1>{i18n.t("print-notes.side-notes")}</h1>
      </div>
      <div className="print-disclaimer">
        {i18n.t("print-notes.print-disclaimer", { email: Fraction.User.email })}
      </div>
    </div>
  );
};

module.exports = PrintNotes;
